document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('predictive-search').forEach((predictiveSearch) => {
    const panel = predictiveSearch.querySelector(
      '[data-empty-search-recommendations]'
    );
    const input = predictiveSearch.querySelector('input[type="search"]');

    if (!panel || !input) return;

    const viewport = panel.querySelector('[data-empty-search-viewport]');
    const track = panel.querySelector('.empty-search-carousel__track');
    const previousButton = panel.querySelector('[data-empty-search-previous]');
    const nextButton = panel.querySelector('[data-empty-search-next]');
    const products = track
      ? Array.from(track.querySelectorAll('.empty-search-product'))
      : [];

    let currentIndex = 0;

    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

    const updateVisibility = () => {
      const hasSearchTerm = input.value.trim().length > 0;

      panel.hidden = hasSearchTerm;

     if (!hasSearchTerm) {
  positionMobilePanel();
  updateCarousel();
}
    };

    const positionMobilePanel = () => {
  if (!isMobile()) {
    panel.style.removeProperty('--empty-search-mobile-top');
    return;
  }

  const searchPosition = predictiveSearch.getBoundingClientRect();

  panel.style.setProperty(
    '--empty-search-mobile-top',
    `${Math.max(0, searchPosition.bottom)}px`
  );
};

    const hidePanel = () => {
      panel.hidden = true;
    };

    const getMaximumIndex = () => {
      if (isMobile()) return 0;
      return Math.max(0, products.length - 3);
    };

    const updateCarousel = () => {
      if (!track) return;

      if (isMobile()) {
        currentIndex = 0;
        track.style.transform = '';
        return;
      }

      const firstProduct = products[0];

      if (!firstProduct) return;

      const trackStyles = window.getComputedStyle(track);
      const gap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
      const movement = firstProduct.getBoundingClientRect().width + gap;
      const maximumIndex = getMaximumIndex();

      currentIndex = Math.min(currentIndex, maximumIndex);
      track.style.transform = `translateX(-${currentIndex * movement}px)`;

      if (previousButton) {
        previousButton.disabled = currentIndex === 0;
      }

      if (nextButton) {
        nextButton.disabled = currentIndex >= maximumIndex;
      }
    };

    input.addEventListener('focus', updateVisibility);
    input.addEventListener('click', updateVisibility);
    input.addEventListener('input', updateVisibility);

    if (previousButton) {
      previousButton.addEventListener('click', () => {
        currentIndex = Math.max(0, currentIndex - 1);
        updateCarousel();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        currentIndex = Math.min(getMaximumIndex(), currentIndex + 1);
        updateCarousel();
      });
    }

    const details = predictiveSearch.closest('details');

    if (details) {
      details.addEventListener('toggle', () => {
        if (details.open) {
          updateVisibility();
        } else {
          hidePanel();
        }
      });
    }

    window.addEventListener('resize', () => {
  positionMobilePanel();
  updateCarousel();
});

    updateCarousel();
  });
});